module.exports = __webpack_public_path__ + "img/9788950926694.49011eef.jpg";